var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgDesign(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 744.184,
    height: 800.076,
    viewBox: "0 0 744.184 800.076",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    role: "img",
    artist: "Katerina Limpitsouni",
    source: "https://undraw.co/",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(-780.246 -161.184)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(780.246 331.173)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M481.229,329.335h0a23.954,23.954,0,0,0-9.984-5.86L443.72,293.47l-14.514,13.913,29.5,28.948A23.519,23.519,0,0,0,464.971,346c7.061,6.751,16.419,8.484,20.905,3.876s2.428-13.8-4.62-20.531h-.026Z",
    transform: "translate(-234.042 -58.101)",
    fill: "#ed9da0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M581.124,348.7l-14.617,18.377-75.556-57.192-.065-.131-44.153-82.394a28.26,28.26,0,1,1,51.306-23.441L526.686,278.9l54.44,69.774v.026Z",
    transform: "translate(-345.408 -90.976)",
    fill: "#6c63ff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M518.269,164.58h30.8v48.865l-33.96-11.159Z",
    transform: "translate(-406.972 -97.433)",
    fill: "#ed9da0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M560.07,156.929a33.833,33.833,0,1,0,0,.008Z",
    transform: "translate(-388.344 -110.091)",
    fill: "#ed9da0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M515.939,181.6l-3.3,6.265L498.071,160.18c-8.77-26.86,21.861-42.287,21.861-42.287,10-11.772,30.084,2,30.084,2C578.99,113.455,565,137.875,565,137.875s-9.88.218-9.88,8.21-10.767,7.44-10.767,7.44l-8.436,14.761-4.659-5.662c-17.32-7.335-15.323,18.977-15.323,18.977Z",
    transform: "translate(-401.98 -113.133)",
    fill: "#090814"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 27.33,
    height: 38.776,
    transform: "translate(98.818 567.843)",
    fill: "#ed9da0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M545.737,606.251c-11.994,0-29.507-1.253-29.641-1.266-4.682.418-28.074,2.258-29.236-3.093a22.982,22.982,0,0,1,.731-10.767c2.258-22.358,3.093-22.618,3.593-22.762.8-.235,3.119.871,6.891,3.3l.235.157.052.274c.065.34,1.736,8.549,9.658,7.295,5.43-.861,7.186-2.062,7.752-2.649a3.339,3.339,0,0,1-1.436-1.2,4.2,4.2,0,0,1-.3-3.5,55.351,55.351,0,0,1,4.2-9.437l.353-.626,31.056,20.957,19.186,5.482a4.908,4.908,0,0,1,3.2,2.831h0a4.947,4.947,0,0,1-1.253,5.586c-3.484,3.132-10.416,8.493-17.671,9.162-1.932.183-4.49.248-7.361.248h0Z",
    transform: "translate(-392.975 23.836)",
    fill: "#090814"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 27.33,
    height: 38.776,
    transform: "translate(37.3 557.016) rotate(-140.436)",
    fill: "#ed9da0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M611,581.7c-9.241-7.648-21.94-19.773-22.031-19.864-3.876-2.649-23.075-16.145-20.557-21.014a22.773,22.773,0,0,1,7.427-7.831c15.988-15.805,16.784-15.461,17.267-15.257.77.327,1.851,2.649,3.211,6.93l.078.261-.131.248c-.183.314-4.124,7.713,2.78,11.785,4.737,2.793,6.852,2.989,7.661,2.9a3.331,3.331,0,0,1-.34-1.851,4.208,4.208,0,0,1,2-2.884,55.538,55.538,0,0,1,9.255-4.594l.665-.261,10.571,35.944,11.29,16.458a4.952,4.952,0,0,1,.653,4.229h0a4.964,4.964,0,0,1-4.528,3.51c-4.672.2-13.431-.091-19.447-4.2-1.592-1.1-3.6-2.675-5.821-4.5h0Z",
    transform: "translate(-568.188 10.317)",
    fill: "#090814"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M586.437,319.1,544.776,628.983H513.527L492.7,319.1h93.746Z",
    transform: "translate(-415.104 -50.281)",
    fill: "#090814"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M554.917,488.366,492.7,569.09l26.625,21.994L626.1,489.53l9.541-170.43-19.094,17.071Z",
    transform: "translate(-464.295 -50.281)",
    fill: "#090814"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M575.892,181.188l19.093,182.294H501.239l-7.27-59.163a170.725,170.725,0,0,1,21.248-105.506L529.6,173.676l46.294,7.513h0Z",
    transform: "translate(-423.64 -94.659)",
    fill: "#6c63ff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M537.755,370.062h0a23.881,23.881,0,0,0-6.656-9.473l-12.6-38.74-18.99,6.642,14.813,38.568a23.383,23.383,0,0,0,1.683,11.407c3.615,9.058,11.421,14.527,17.411,12.2s7.922-11.551,4.307-20.609h.026Z",
    transform: "translate(-377.098 -49.441)",
    fill: "#ed9da0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M576.605,391.539l-20.921,10.65L510.669,318.8v-.143l-5.988-93.279a28.261,28.261,0,1,1,56.409,0l-5.051,80.1,20.57,86.075h0Z",
    transform: "translate(-420.817 -88.055)",
    fill: "#6c63ff"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(1100.294 161.184)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M218.06,154.13a143.391,143.391,0,1,1,0,286.781c-79.192,0-188.792-78.517-143.391-143.391S138.868,154.13,218.06,154.13Z",
    transform: "translate(-15.945 -31.55)",
    fill: "#f2f2f2"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M361.113,159.982a2.334,2.334,0,0,0-2.332,2.332v74.61a2.332,2.332,0,0,0,4.663,0v-74.61A2.334,2.334,0,0,0,361.113,159.982Z",
    transform: "translate(32.92 -30.58)",
    fill: "#3f3d56"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M25.113,111.982a2.334,2.334,0,0,0-2.332,2.332v18.652a2.332,2.332,0,1,0,4.663,0V114.313A2.334,2.334,0,0,0,25.113,111.982Z",
    transform: "translate(-22.782 -38.538)",
    fill: "#3f3d56"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M25.113,159.982a2.334,2.334,0,0,0-2.332,2.332v36.139a2.332,2.332,0,1,0,4.663,0V162.313A2.334,2.334,0,0,0,25.113,159.982Z",
    transform: "translate(-22.782 -53.722)",
    fill: "#3f3d56"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M25.113,203.982a2.334,2.334,0,0,0-2.332,2.332v36.139a2.332,2.332,0,0,0,4.663,0V206.313A2.334,2.334,0,0,0,25.113,203.982Z",
    transform: "translate(-22.782 -47.593)",
    fill: "#3f3d56"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M204.487,48.982a2.334,2.334,0,0,0-2.332,2.332V87.452a2.332,2.332,0,0,0,4.663,0V51.313a2.334,2.334,0,0,0-2.332-2.332Z",
    transform: "translate(6.954 -48.982)",
    fill: "#3f3d56"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M153.851,278.738h-80.7v-2.332h80.7a12.728,12.728,0,0,0,12.713-12.714V209.13H168.9v54.562a15.062,15.062,0,0,1-15.045,15.046Z",
    transform: "translate(-14.431 -22.433)",
    fill: "#6c63ff"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 183.535,
    height: 2.332,
    transform: "translate(109.86 374.58)",
    fill: "#6c63ff"
  }), /*#__PURE__*/React.createElement("g", {
    transform: "translate(302.216 124.69)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M389.648,271.965H291.616a9.605,9.605,0,0,1-9.594-9.594V165.534a9.605,9.605,0,0,1,9.594-9.594h98.032a9.605,9.605,0,0,1,9.594,9.594v96.836A9.605,9.605,0,0,1,389.648,271.965Z",
    transform: "translate(-282.021 -155.94)",
    fill: "#090814"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M309.466,158.392a24.992,24.992,0,0,0-24.992,24.992V259.91a8.79,8.79,0,0,0,8.79,8.79h59.944a42.769,42.769,0,0,0,42.769-42.769V167.182a8.79,8.79,0,0,0-8.79-8.79Z",
    transform: "translate(-281.615 -155.534)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("g", {
    transform: "translate(8.918 27.352)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M362.575,183.05H309.858a1.824,1.824,0,1,1,0-3.648h52.717a1.824,1.824,0,0,1,0,3.648Z",
    transform: "translate(-286.627 -179.402)",
    fill: "#d6d6e3"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M362.575,216.414H309.858a1.824,1.824,0,1,1,0-3.648h52.717a1.824,1.824,0,0,1,0,3.648Z",
    transform: "translate(-286.627 -173.872)",
    fill: "#d6d6e3"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M387.027,199.743H291.495a1.824,1.824,0,1,1,0-3.648h95.532a1.824,1.824,0,0,1,0,3.648Z",
    transform: "translate(-289.671 -176.635)",
    fill: "#d6d6e3"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M379.186,229.98H344.675a1.824,1.824,0,1,1,0-3.648h34.511a1.824,1.824,0,0,1,0,3.648Z",
    transform: "translate(-280.855 -171.623)",
    fill: "#d6d6e3"
  }))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(118.466 341.524)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M209.864,434.072H132.02a7.627,7.627,0,0,1-7.619-7.619V349.559a7.627,7.627,0,0,1,7.619-7.619h77.844a7.627,7.627,0,0,1,7.619,7.619v76.895a7.627,7.627,0,0,1-7.619,7.619h0Z",
    transform: "translate(-124.402 -341.94)",
    fill: "#090814"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M146.194,343.887a19.846,19.846,0,0,0-19.846,19.846V424.5a6.98,6.98,0,0,0,6.98,6.98h47.6a33.962,33.962,0,0,0,33.962-33.962v-46.65a6.98,6.98,0,0,0-6.98-6.98H146.194Z",
    transform: "translate(-124.079 -341.617)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("g", {
    transform: "translate(7.081 21.719)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M188.367,363.467H146.506a1.448,1.448,0,1,1,0-2.9h41.861a1.448,1.448,0,0,1,0,2.9Z",
    transform: "translate(-128.059 -360.571)",
    fill: "#d6d6e3"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M188.367,389.96H146.506a1.448,1.448,0,1,1,0-2.9h41.861a1.448,1.448,0,0,1,0,2.9Z",
    transform: "translate(-128.059 -356.179)",
    fill: "#d6d6e3"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M207.783,376.723H131.924a1.448,1.448,0,1,1,0-2.9h75.859a1.448,1.448,0,0,1,0,2.9Z",
    transform: "translate(-130.476 -358.373)",
    fill: "#d6d6e3"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M201.557,400.732h-27.4a1.448,1.448,0,1,1,0-2.9h27.4a1.448,1.448,0,0,1,0,2.9Z",
    transform: "translate(-123.475 -354.393)",
    fill: "#d6d6e3"
  }))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(86.317 117.974)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M160.028,218.315H102.459a5.641,5.641,0,0,1-5.634-5.634V155.814a5.641,5.641,0,0,1,5.634-5.634h57.569a5.641,5.641,0,0,1,5.634,5.634v56.867a5.641,5.641,0,0,1-5.634,5.634h0Z",
    transform: "translate(-96.824 -150.179)",
    fill: "#090814"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M112.941,151.619A14.677,14.677,0,0,0,98.264,166.3v44.939a5.162,5.162,0,0,0,5.162,5.162h35.2a25.116,25.116,0,0,0,25.116-25.116v-34.5a5.162,5.162,0,0,0-5.162-5.162H112.941Z",
    transform: "translate(-96.586 -149.941)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("g", {
    transform: "translate(5.237 16.062)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M144.129,166.1H113.171a1.071,1.071,0,1,1,0-2.142h30.958a1.071,1.071,0,0,1,0,2.142Z",
    transform: "translate(-99.529 -163.958)",
    fill: "#d6d6e3"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M144.129,185.692H113.171a1.071,1.071,0,1,1,0-2.142h30.958a1.071,1.071,0,0,1,0,2.142Z",
    transform: "translate(-99.529 -160.71)",
    fill: "#d6d6e3"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M158.489,175.9h-56.1a1.071,1.071,0,1,1,0-2.142h56.1a1.071,1.071,0,0,1,0,2.142Z",
    transform: "translate(-101.316 -162.332)",
    fill: "#d6d6e3"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M153.884,193.659H133.618a1.071,1.071,0,1,1,0-2.142h20.267a1.071,1.071,0,0,1,0,2.142Z",
    transform: "translate(-96.139 -159.389)",
    fill: "#d6d6e3"
  }))), /*#__PURE__*/React.createElement("circle", {
    cx: 16.321,
    cy: 16.321,
    r: 16.321,
    transform: "translate(288.673 219.153)",
    fill: "#6c63ff"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 11.658,
    cy: 11.658,
    r: 11.658,
    transform: "translate(141.496 175.041)",
    fill: "#6c63ff"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 13.989,
    cy: 13.989,
    r: 13.989,
    transform: "translate(195.119 329.301)",
    fill: "#6c63ff"
  }), /*#__PURE__*/React.createElement("g", {
    transform: "translate(219.762 6.002)"
  }, /*#__PURE__*/React.createElement("ellipse", {
    cx: 14.529,
    cy: 14.223,
    rx: 14.529,
    ry: 14.223,
    transform: "translate(0 0.374)",
    fill: "#d6d6e3"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M335.482,63.862H257.276a4.866,4.866,0,1,1,0-9.732h78.206a4.866,4.866,0,1,1,0,9.732Z",
    transform: "translate(-204.477 -54.13)",
    fill: "#d6d6e3"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M396.515,77.989H257.276a4.866,4.866,0,1,1,0-9.732H396.515a4.866,4.866,0,1,1,0,9.732Z",
    transform: "translate(-204.477 -51.788)",
    fill: "#d6d6e3"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(14.585 75.949)"
  }, /*#__PURE__*/React.createElement("ellipse", {
    cx: 9.403,
    cy: 9.205,
    rx: 9.403,
    ry: 9.205,
    transform: "translate(0 0.242)",
    fill: "#6c63ff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M115.667,120.429H65.053a3.149,3.149,0,1,1,0-6.3h50.614a3.149,3.149,0,0,1,0,6.3Z",
    transform: "translate(-30.882 -114.13)",
    fill: "#6c63ff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M155.166,129.571H65.053a3.149,3.149,0,1,1,0-6.3h90.113a3.149,3.149,0,0,1,0,6.3Z",
    transform: "translate(-30.882 -112.615)",
    fill: "#6c63ff"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(296.704 403.532)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(0)"
  }, /*#__PURE__*/React.createElement("ellipse", {
    cx: 9.403,
    cy: 9.205,
    rx: 9.403,
    ry: 9.205,
    transform: "translate(0 0.242)",
    fill: "#6c63ff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M357.667,401.429H307.053a3.149,3.149,0,0,1,0-6.3h50.614a3.149,3.149,0,0,1,0,6.3Z",
    transform: "translate(-272.882 -395.13)",
    fill: "#6c63ff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M397.166,410.571H307.053a3.149,3.149,0,0,1,0-6.3h90.113a3.149,3.149,0,0,1,0,6.3Z",
    transform: "translate(-272.882 -393.615)",
    fill: "#6c63ff"
  }))), /*#__PURE__*/React.createElement("rect", {
    width: 2.332,
    height: 110.749,
    transform: "translate(190.748 124.725)",
    fill: "#090814"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 6.995,
    cy: 6.995,
    r: 6.995,
    transform: "translate(184.919 228.48)",
    fill: "#090814"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 6.995,
    cy: 6.995,
    r: 6.995,
    transform: "translate(291.004 308.918)",
    fill: "#090814"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 6.995,
    cy: 6.995,
    r: 6.995,
    transform: "translate(102.148 213.325)",
    fill: "#090814"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 38.27,
    height: 2.333,
    transform: "matrix(1, -0.03, 0.03, 1, 68.307, 221.487)",
    fill: "#090814"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M335.465,346.748h-58V319.97h2.332v24.446h55.673Z",
    transform: "translate(19.438 -4.058)",
    fill: "#090814"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 6.995,
    cy: 6.995,
    r: 6.995,
    transform: "translate(99.277 289.7)",
    fill: "#090814"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M170.409,330.263h-58V303.486h2.332v24.446h55.673Z",
    transform: "translate(-7.924 -6.791)",
    fill: "#090814"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 278.6,
    height: 2.332,
    transform: "translate(61.367 270.08)",
    fill: "#090814"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDesign);
export default __webpack_public_path__ + "static/media/design.783f0c3163372cee51f736926c5fc3ea.svg";
export { ForwardRef as ReactComponent };